module.exports = __webpack_public_path__ + "static/media/email.a28cc035.svg";